import { Box, Container, Link, Typography } from '@mui/material'
import { useAuth0 } from '@auth0/auth0-react'
import { Loading } from '../Loading'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { isAlreadyRequestedApiProcess, sendRequestData, setTagsApiProcess } from './function'
import { isEmpty, isNil, replace } from 'lodash/fp'
import ClosedPage from '../ClosedPage'
import { ClosedReason } from '../../types'
const env = process.env['REACT_APP_ENV'] ?? 'dev'
const LOCALSTRAGE_KEY = "shopify-global-id"

const getQueryParam = (serchParams: URLSearchParams, key: string): string | null => {
  const value = serchParams.get(key)
  return value
}

const storeQueryParam = (serchParams: URLSearchParams, localstorageKey: string, key: string): string | undefined => {
  const value = getQueryParam(serchParams, key)
  if (!isEmpty(value)) {
    localStorage.setItem(localstorageKey, value)
    return value
  }
  return undefined
}

const redirectToUrl = (url: string) => {
  window.location.href = url
}

const RedirectLoding = () => {
  const useQuery = new URLSearchParams(useLocation().search)
  storeQueryParam(useQuery, LOCALSTRAGE_KEY, "customerId")
  return <Box>
    <Box display={"grid"} justifyContent={"center"}>
      <Box display={"flex"} justifyContent={"center"}>
        <Typography variant="h6" color="gray">リダイレクト中です...</Typography>
      </Box>
      <Box marginY={2}><Loading /></Box>
      <Box display={"flex"} justifyContent={"center"}>
        <Typography color="gray" sx={{ whiteSpace: 'pre-line', fontSize: 15 }}>
          ※現在システム障害によりiOS端末（iPhone / iPad）をご利用の場合、OSバージョンやブラウザ設定、 ネットワーク環境によりアクセスできない、または正しく表示されない場合があります。<br /><br />
          ※画面が切り替わらない場合はお手数ですがPC等、iOS以外の端末からアクセスしてください。<br /><br />
          ※本件に関するお問い合わせは<Link href="https://form.run/@miraiz-connect-nLYfeyfoxECC5kq4b4oK">こちら</Link>までお願いいたします。
        </Typography>
      </Box>
    </Box>
  </Box>
}

const RedirectPage = () => {
  const useQuery = new URLSearchParams(useLocation().search)
  const { isAuthenticated, isLoading, getAccessTokenSilently, loginWithRedirect } = useAuth0()
  const campaignCode = { prd: '2b62310a-bf7f-484b-880e-3c70b4f975d2', stg: 'c9c9f5ea-0b69-4d3d-920d-578f59736883-dummy', dev: 'c9c9f5ea-0b69-4d3d-920d-578f59736883-dummy' }[env] as string
  const [isAlreadyRequested, setIsAlreadyRequested] = useState<boolean | undefined>(false)
  const [isMaintenance, setIsMaintenance] = useState<boolean>(false)
  const [isConnecting, setIsConnecting] = useState<boolean>(true)

  storeQueryParam(useQuery, LOCALSTRAGE_KEY, "customerId")
  useEffect(() => {
    const checkAuth = async () => {
      if (!isAuthenticated && !isLoading) {
        try {
          await getAccessTokenSilently()
        } catch (error) {
          loginWithRedirect()
        }
      } else if (isAuthenticated && !isLoading) {
        const token = await getAccessTokenSilently({ authorizationParams: { audience: "https://app.fdh.miraiz-connect.jp/" } })
        isAlreadyRequestedApiProcess(token, campaignCode).then((isAlreadyRequestedApiRes) => {
          setIsAlreadyRequested(isAlreadyRequestedApiRes)
          const shopifyGlobalId = localStorage.getItem(LOCALSTRAGE_KEY)
          const customerId = replace('gid://shopify/Customer/', '')(shopifyGlobalId ?? '')
          if (!isNil(isAlreadyRequestedApiRes)) {
            setIsAlreadyRequested(isAlreadyRequestedApiRes)
            setIsConnecting(false)
            if (!isAlreadyRequestedApiRes) {
              sendRequestData(token, shopifyGlobalId).then((sendRequestResult) => {
                if (sendRequestResult) {
                  setTagsApiProcess(customerId, campaignCode, token).then((setResult) => {
                    if (isNil(setResult) || !setResult) {
                      setIsMaintenance(true)
                      setIsConnecting(false)
                    } else {
                      localStorage.removeItem(LOCALSTRAGE_KEY)
                      redirectToUrl("https://www.miraiz-connect-tsunagu.com/pages/katene-campaign-2025aw-portal")
                    }
                  }).catch(() => {
                    setIsMaintenance(true)
                    setIsConnecting(false)
                  })
                } else {
                  setIsMaintenance(true)
                  setIsConnecting(false)
                }
              }).catch(() => {
                setIsMaintenance(true)
                setIsConnecting(false)
              })
            }
          } else {
            setIsMaintenance(true)
            setIsConnecting(false)
          }
        }).catch(() => {
          setIsMaintenance(true)
          setIsConnecting(false)
        })

      }
    }
    checkAuth()
  }, [isAuthenticated, isLoading, getAccessTokenSilently, loginWithRedirect])
  return (
    <Box>
      {isLoading ?
        <Loading /> :
        isConnecting ?
          <RedirectLoding /> :
          isAlreadyRequested ?
            <ClosedPage reason={ClosedReason.alreadyRequested} /> :
            isMaintenance ?
              <ClosedPage reason={ClosedReason.campaignMaintenance} /> :
              <Box>
                <Container maxWidth="xl">
                  <Box display={"grid"} justifyContent={"center"}>
                    <Box display={"flex"} justifyContent={"center"}><Typography variant="h6" color="gray">リダイレクト中です...</Typography></Box>
                    <Loading />
                    <Box display={"flex"} justifyContent={"center"} marginTop={9}>
                      <Typography color="gray">※30秒以上画面が切り替わらない場合は、お手数ですが再度<Link href="https://katene.chuden.jp/clubkatene/p/campaign/kurashi_prj/otoku/tsunagustore-cp/">キャンペーンページ</Link>よりお申込みください。</Typography>
                    </Box>
                  </Box>
                </Container>
              </Box>
      }
    </Box>
  )
}

export default RedirectPage
